import { FormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function RequiredIf(controlName: string, control2Name:string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const control2 = formGroup.controls[control2Name];
        if (control2.value && (control.value === "" || control.value == null)) {
            control.setErrors({ GreaterThan: false });
        } else {
            control.setErrors(null);
        }
    }
}